var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCheckMs(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "12px",
    viewBox: "0 0 16 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icCheckMS") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0.184615385,6.6 C0.0615384615,6.48 0,6.3 0,6.18 C0,6.06 0.0615384615,5.88 0.184615385,5.76 L1.04615385,4.92 C1.29230769,4.68 1.66153846,4.68 1.90769231,4.92 L1.96923077,4.98 L5.35384615,8.52 C5.47692308,8.64 5.66153846,8.64 5.78461538,8.52 L14.0307692,0.18 L14.0923077,0.18 L14.0923077,0.18 C14.3384615,-0.06 14.7076923,-0.06 14.9538462,0.18 L15.8153846,1.02 C16.0615385,1.26 16.0615385,1.62 15.8153846,1.86 L15.8153846,1.86 L5.96923077,11.82 C5.84615385,11.94 5.72307692,12 5.53846154,12 C5.35384615,12 5.23076923,11.94 5.10769231,11.82 L0.307692308,6.78 L0.184615385,6.6 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web-upgrade",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Compare-membership",
    transform: "translate(-129.000000, -323.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UI/icon/tick-Copy-4",
    transform: "translate(129.000000, 323.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icCheckMS",
    fill: "#7BCB45",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCheckMs);
export default __webpack_public_path__ + "static/media/icCheckMS.82934565a4372b9c9aebb83270dd8964.svg";
export { ForwardRef as ReactComponent };